import { render, staticRenderFns } from "./StartWithPhonePage.vue?vue&type=template&id=197be7be&scoped=true"
import script from "./StartWithPhonePage.vue?vue&type=script&lang=js"
export * from "./StartWithPhonePage.vue?vue&type=script&lang=js"
import style0 from "./StartWithPhonePage.vue?vue&type=style&index=0&id=197be7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197be7be",
  null
  
)

export default component.exports